module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 400 400",
      "version": "1.1"
    }
  }, [_c('defs', {
    attrs: {
      "id": "defs6"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
      "id": "g10"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(178.0626,235.0086)",
      "id": "g12"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#4dba87",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "id": "path14",
      "d": "M 0,0 -22.669,-39.264 -45.338,0 h -75.491 L -22.669,-170.017 75.491,0 Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(178.0626,235.0086)",
      "id": "g16"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#435466",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "id": "path18",
      "d": "M 0,0 -22.669,-39.264 -45.338,0 H -81.565 L -22.669,-102.01 36.227,0 Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91d904c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/about/foldable/VueIcon.vue
// module id = 212
// module chunks = 5